import { ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface KeyValueRow {
  label: string;
  value: ReactNode;
  mono?: boolean;
}

interface Props {
  rows: KeyValueRow[];
  className?: string;
}

export function KeyValueGrid({ rows, className }: Props) {
  return (
    <dl
      className={cn(
        "grid grid-cols-[max-content_1fr] gap-x-6 gap-y-2 text-sm",
        className,
      )}
    >
      {rows.map((row) => (
        <div key={row.label} className="contents">
          <dt className="text-xs uppercase tracking-wide text-muted-foreground self-center">
            {row.label}
          </dt>
          <dd
            className={cn("tabular-nums", row.mono && "font-mono text-[13px]")}
          >
            {row.value ?? <span className="text-muted-foreground">—</span>}
          </dd>
        </div>
      ))}
    </dl>
  );
}
